/* eslint-disable no-empty-pattern */
import React, { useContext, useEffect } from "react";
import { StateContext } from "../../contextApi";
import { closeModalOnClick } from "../../util/util";
import VerifyingIcon from '../../assets/img/kuda-verify.inline.svg';
import styled from "styled-components";

const BVNVerifyModal = () => {

    const [{ }, dispatch] = useContext(StateContext)


    const closeModal = async () => {
        dispatch({
            key: "verifyBVNForm",
            value: false,
            type: 'CHANGE_VIEW_MODALS'
        });
    }

    useEffect(() => {
        document.body.classList.add("backdrop-init");
        closeModalOnClick(closeModal);
        return () => {
            document.body.classList.remove("backdrop-init");
        }
    }, [])



    return (
        <VerifyBVNStyled>
            <div className="modal modal-sendMoney small-modal modal-backdrop fadeIn animated">
                <div className="modal-content fadeInUp animated">
                    <div className="kuda-modal--content">
                        <h4 className="color-black text-xbold heading text-center">We’re verifying your details.</h4>

                        <div className="kuda-modal-illustration">
                            <VerifyingIcon />
                        </div>
                        {/* style={{maxWidth: 'fit-content'}} */}
                        <div className="message-response withdrawal-response text-center bottom--spacing" >
                            <p className="color-black">Thank you for giving us details about yourself. We'll let you know as soon as we're done verifying them.</p>
                        </div>

                        <div className="d-flex justify-content-center mt-5">
                            <div className="addAction kuda-cta kuda-cta-lg" onClick={closeModal}>Okay</div>
                        </div>
                    </div>
                </div>
            </div>
        </VerifyBVNStyled>
    );
}

const VerifyBVNStyled = styled.div`

.heading { 
    max-width: 267px;
    margin: auto;
    margin-bottom: 3rem;
}

.message-response{
    max-width: 335px;
    margin-top: 3rem;
}
`
export default BVNVerifyModal;